import { DialogsProvider } from "@/context/DialogsContext";
import Header from "@/components/Header";
import MobileStickyBar from "@/components/MobileStickyBar";
import Hero from "@/components/Hero";
import QuickEstimateSection from "@/components/QuickEstimateSection";
import PillarsSection from "@/components/PillarsSection";
import FormulesSection from "@/components/FormulesSection";
import ReviewsSection from "@/components/ReviewsSection";
import LocalCompanySection from "@/components/LocalCompanySection";
import ReassuranceSection from "@/components/ReassuranceSection";
import ProofsSection from "@/components/ProofsSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import GroupageSection from "@/components/GroupageSection";
import LongDistanceSection from "@/components/LongDistanceSection";
import ProfileSelection from "@/components/ProfileSelection";
import PricingSection from "@/components/PricingSection";
import ZonesSection from "@/components/ZonesSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import QuoteFormDialog from "@/components/forms/QuoteFormDialog";
import { useSEO } from "@/hooks/useSEO";
import { localBusinessSchema, faqSchema } from "@/lib/schema";
import { FAQ_ITEMS } from "@/constants/business";

const META_TITLE = "Transport et déménagement au Havre et sa région | Express Delivery";
const META_DESCRIPTION =
  "Express Delivery organise vos transports de meubles, déménagements, manutention, groupage et longues distances au Havre, dans sa région et partout en France.";

export default function LandingPage() {
  useSEO({
    title: META_TITLE,
    description: META_DESCRIPTION,
    path: "/",
    isIndexable: true,
    jsonLd: [localBusinessSchema(), faqSchema(FAQ_ITEMS)],
  });

  return (
    <DialogsProvider>
      <div className="pb-16 md:pb-0" data-testid="landing-page">
        <Header />
        <MobileStickyBar />
        <Hero />
        <QuickEstimateSection />
        <PillarsSection />
        <FormulesSection />
        <ReviewsSection />
        <LocalCompanySection />
        <ReassuranceSection />
        <ProofsSection />
        <HowItWorksSection />
        <GroupageSection />
        <LongDistanceSection />
        <ProfileSelection />
        <PricingSection />
        <ZonesSection />
        <FAQSection />
        <ContactSection />
        <Footer />
        <QuoteFormDialog />
      </div>
    </DialogsProvider>
  );
}
